/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import  { Container, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import {
    object,
} from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';
import ReactHTMLParser from 'react-html-parser';
import Data from './ViewData';

const styles = (theme) => {
    const { breakpoints: { minWidth, maxWidth } } = theme;

    return ({
        root: {
            '& .affiliates-content': {
                position: 'relative',
                minHeight: '1px',
                padding: '50px 10px',
                [theme.breakpoints.down(576)]: {
                    padding: '50px 0',
                },
                '& .header': {
                    fontFamily: 'BebasNeue',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    marginBottom: '3rem !important',
                    lineHeight: '38px',
                    fontSize: '2.5rem',
                    fontWeight: '500',
                    marginTop: '0',
                },
                '& .benefits-wrapper': {
                    background: '#BFBFBF',
                    padding: '20px 15px',
                    '& .section-heading': {
                        marginBottom: '0.5rem',
                        fontWeight: 500,
                        lineHeight: 1.2,
                        fontSize: '1.5rem',
                        paddingBottom: '0',
                    },
                    '& .apply-button': {
                        margin: '0 auto',
                        marginBottom: '1rem !important',
                        marginTop: '0.5rem !important',
                        padding: 0,
                        [theme.breakpoints.up(992)]: {
                            maxWidth: '50%',
                        },
                        [theme.breakpoints.down(991)]: {
                            maxWidth: '66.66667%',
                        },
                        [theme.breakpoints.down(576)]: {
                            maxWidth: '100%',
                        },
                        '& a': {
                            margin: '0',
                        },
                    },
                    '& p': {
                        display: 'flex',
                        marginBottom: '0',
                        [theme.breakpoints.up(minWidth?.small_screen_up)]: {
                            width: '60%',
                            margin: '0 auto',
                        },
                        [theme.breakpoints.down(576)]: {
                            marginTop: '0',
                        },
                        '& span': {
                            display: 'block',
                            padding: '4px 3px',
                            fontSize: '0.875rem',
                            '& svg': {
                                fontSize: '1.125rem',
                                fverticalAlign: theme.palette.common?.black,
                                width: '1em',
                                height: '1em',
                                flexShrink: '0',
                            },
                        },
                    },
                },
                '& .divider': {
                    borderTop: `2px solid ${theme.palette.common?.black}`,
                    marginTop: '20px',
                    marginBottom: '20px',
                },
                '& .about-program-section': {
                    '& .apply-button': {
                        margin: '0 auto',
                    },
                    '& div': {
                        padding: '0 15px',
                        textAlign: 'center',
                        [theme.breakpoints.down(576)]: {
                            padding: '0 !important',
                        },
                        '& p': {
                            marginTop: '0',
                        },
                        '& ul': {
                            textAlign: 'left !important',
                        },
                    },
                    '& svg': {
                        width: '60px',
                        padding: '10px 0',
                        '& .a': {
                            fill: '#B9E525',
                        },
                    },
                    '& a': {
                        backgroundColor: '#B9E525',
                    },
                    '& .br-right': {
                        [theme.breakpoints.up(minWidth?.small_screen_down)]: {
                            borderRight: `1px solid ${theme.palette.common?.gray}`,
                        },
                    },
                },
                '& .faq-section': {
                    backgroundColor: '#B9E525',
                    padding: '20px',
                    textAlign: 'center',
                    '& h4': {
                        flex: 'auto',
                        marginBottom: '20px',
                    },
                    '& .faq-half': {
                        [theme.breakpoints.up(minWidth?.small_screen_down)]: {
                            borderLeft: `1px dotted ${theme.palette.common?.white}`,
                        },
                    },
                },
                '& .contact-us-section': {
                    marginTop: '20px',
                    textAlign: 'center',
                    [theme.breakpoints.down(576)]: {
                        padding: '0 10px',
                    },
                    '& a': {
                        textDecoration: 'none',
                        fontWeight: 'bold',
                    },
                },
                '& .section-heading': {
                    marginBottom: '0.5rem',
                    fontWeight: 500,
                    lineHeight: 1.2,
                    fontSize: '1.5rem',
                },
                '& .faqs': {
                    marginBottom: '20px',
                },
            },
        },
        container: {
            padding: '0 15px',
            margin: '0 auto',
            [theme.breakpoints.down(maxWidth?.big_screen_wiki_tiles)]: {
                maxWidth: '960px',
            },
            [theme.breakpoints.down(minWidth?.small_medium_down)]: {
                maxWidth: '720px',
            },
            [theme.breakpoints.down(576)]: {
                maxWidth: '540px',
            },
        },
        title: {
            paddingBottom: '5px',
            textAlign: 'center',
            marginBottom: '0.5rem',
            fontWeight: 500,
            lineHeight: 1.2,
            fontSize: '1.5rem',
            fontFamily: 'Hind, sans-serif',
        },
        description: {
            textAlign: 'center',
            padding: '0 15px',
            '& p': {
                fontSize: '1rem',
                lineHeight: '1.5em',
                marginTop: '0',
            },
        },
        right: {
            background: theme.palette.colorNeutral40,
            padding: 20,
            textAlign: 'center',
            '& span': {
                display: 'block',
                fontSize: 14,
                padding: '4px 3px',
            },
        },
        button: {
            textAlign: 'center',
            paddingBottom: '20px',
            '& a': {
                color: theme.palette.common?.black,
                background: '#B9E525',
                padding: '8px 25px',
                display: 'inline-block',
                textDecoration: 'none',
                textTransform: 'uppercase',
                fontSize: '1.25rem',
                fontWeight: 700,
                margin: '10px 0',
                width: '100%',
            },
        },
        divider: {
            borderTop: `2px solid ${theme.palette.crDividerColor}`,
            width: '100%',
            margin: '20px 0',
        },
        aboutProgramDes: {
            maxWidth: '90%',
            margin: 'auto',
            textAlign: 'center',
            padding: '0 50px',
            [theme.breakpoints.down(576)]: {
                padding: '0 !important',
                margin: '0',
                width: '100%',
                maxWidth: '100%',
            },
            '& p': {
                fontSize: '1rem',
                lineHeight: '1.5em',
                '& a': {
                    color: theme.palette.common?.black,
                    fontWeight: 600,
                },
            },
            '& img': {
                width: '60px',
                padding: '10px 0',
            },
        },
        borderRight: {
            borderRight: '1px solid #BFBFBF',
            [theme.breakpoints.down(576)]: {
                borderRight: 'none',
            },
        },
        termsConDes: {
            textAlign: 'center',
            '& p': {
                fontSize: '1rem',
                lineHeight: 1.5,
                marginTop: '0',
            },
        },
        termsConBottom: {
            textAlign: 'center',
            '& p': {
                fontSize: '1rem',
                lineHeight: '1.5em',
                marginTop: '0',
            },
        },
        faq: {
            textAlign: 'center',
            borderTop: `8px solid ${theme.palette.common?.green}`,
            background: theme.palette.colorPrimary,
            color: theme.palette.common?.white,
            marginTop: 20,
            marginBottom: 25,
            '& p': {
                fontSize: 14,
                fontWeight: 'normal',
                lineHeight: 1.4,
            },
        },
        affiliateFaq: {
            margin: '25px 0px 35px 0',
        },
        faqInner: {
            maxWidth: '86%',
            margin: 'auto',
            [theme.breakpoints.down(576)]: {
                margin: '0',
                maxWidth: '100%',
            },
            '& a': {
                color: theme.palette.common?.white,
                fontWeight: 'bold',
            },
        },
        contactUs: {
            textAlign: 'center',
            '& p': {
                fontSize: 14,
            },
        },
        contactUsInner: {
            maxWidth: '90%',
            margin: 'auto',
            '& a': {
                color: theme.palette.colorPrimary,
                fontSize: 14,
            },
            '& span': {
                fontSize: 14,
            },
        },
        affiliateFaqSubtitle: {
            fontSize: '16px',
            fontWeight: 600,
        },
        faqRightContainer: {
            borderLeft: `1px dotted ${theme.palette.common?.white}`,
            [theme.breakpoints.down(576)]: {
                borderLeft: 'none',
            },
        },
        setBoderOnContactus: {
            borderLeft: `1px dotted ${theme.palette.common?.black}`,
            margin: '20px 0',
            '&:first-child': {
                borderLeft: 'none',
            },
        },
    });
};

const BecomeAnAffiliate = ({ classes }) => {
    const {
        header, about_us: { left_block, right_block }, about_program, terms_condition, faq, contact_us,
    } = Data;

    return (
        <Container className={classes.container}>
            <div className={classes.root}>
                <Grid className="affiliates-content">
                    <h2 className="header">{header}</h2>
                    <Grid container className="about-us-section">
                        <Grid item xs={12} sm={7}>
                            <div className={classes.description}>
                                <div className={classes.title}>{left_block.title}</div>
                                {left_block.description.map((data) => (<p>{data.des}</p>))}
                            </div>
                        </Grid>
                        <Grid className="benefits-wrapper" item xs={12} sm={5}>
                            <div className={`${classes.title} section-heading`}>{right_block.bottom_title}</div>
                            <div className={`${classes.button} apply-button`}>
                                <div>
                                    <Link to={{ pathname: `${right_block?.button?.link}` }} target="_blank">{right_block?.button?.title}</Link>
                                </div>
                            </div>
                            <div className={classes.benefitsBlock}>{right_block.description.map((data) => (<p><span> <CheckIcon /></span><span>{data.des}</span></p>))}</div>
                        </Grid>
                    </Grid>
                    <div className="divider" />
                    <Grid container className="about-program-section">
                        <Grid item xs={12} sm={6} className={classes.borderRight}>
                            <span className={classes.title}>{about_program.left_block.title}</span>
                            <div className={classes.aboutImage}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="101.236"
                                    height="90.896"
                                    viewBox="0 0 101.236 90.896"
                                >
                                    <path
                                        className="a"
                                        d="M1950.107-53.583a17.567,17.567,0,0,0-17.567,17.567,17.567,17.567,0,0,0,17.567,17.567,17.567,17.567,0,0,0,17.567-17.567A17.567,17.567,0,0,0,1950.107-53.583Zm8.655,20.892h-5.33v5.33a3.323,3.323,0,0,1-3.323,3.323h0a3.324,3.324,0,0,1-3.324-3.323v-5.33h-5.33a3.324,3.324,0,0,1-3.324-3.324,3.324,3.324,0,0,1,3.324-3.324h5.33v-5.33a3.326,3.326,0,0,1,3.326-3.326,3.324,3.324,0,0,1,3.323,3.324v5.332h5.33a3.324,3.324,0,0,1,3.324,3.324A3.324,3.324,0,0,1,1958.762-32.691Z"
                                        transform="translate(-1866.438 77.129)"
                                    />
                                    <path
                                        className="a"
                                        d="M1807.3-63.731a23.306,23.306,0,0,1-3.769-.31,39.48,39.48,0,0,1-34.766,20.826,39.49,39.49,0,0,1-39.445-39.445,39.489,39.489,0,0,1,39.445-39.445,39.366,39.366,0,0,1,29.764,13.589,23.055,23.055,0,0,1,6.424-1.6,45.4,45.4,0,0,0-36.188-17.987A45.5,45.5,0,0,0,1723.32-82.66a45.5,45.5,0,0,0,45.448,45.448,45.511,45.511,0,0,0,41.4-26.7A23.35,23.35,0,0,1,1807.3-63.731Z"
                                        transform="translate(-1723.32 128.108)"
                                    />
                                    <g transform="translate(34.026 20.095)">
                                        <g transform="translate(0 16.838)">
                                            <path
                                                className="a"
                                                d="M1852.45,15.4c-2.364,0-4.282-1.145-4.282-2.559V-9.675c0-.848-1.157-1.535-2.573-1.535h-12.486c-1.359.742-1.207,1.575-.433,2.037a2.815,2.815,0,0,0,1.416.35,4.5,4.5,0,0,1,2.268.562A1.665,1.665,0,0,1,1837.3-6.9V12.837c0,1.414-1.918,2.559-4.282,2.559a2.814,2.814,0,0,0-1.416.35,1.032,1.032,0,0,0-.587.842v.855h23.436v-.855C1854.453,15.931,1853.555,15.4,1852.45,15.4Z"
                                                transform="translate(-1831.017 11.21)"
                                            />
                                        </g>
                                        <path
                                            className="a"
                                            d="M1846.082-53.056c-5.388-7.072,2.6-15.063,9.671-9.686C1861.146-55.679,1853.156-47.666,1846.082-53.056Z"
                                            transform="translate(-1840.112 64.504)"
                                        />
                                    </g>
                                </svg>
                            </div>
                            <p>{about_program?.left_block?.description?.[0].des}</p>
                            <ul>
                                {about_program?.left_block?.list.map((data) => (<li>{data.li}</li>))}
                            </ul>
                            <p>{about_program?.left_block?.description?.[1].des}</p>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.aboutProgramDes}>  <span className={classes.title}>{about_program.right_block.title}</span>
                                <div className={classes.aboutImage}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="86.111" height="84.973" viewBox="0 0 86.111 84.973">
                                        <path
                                            className="a"
                                            d="M2490.893-118.608a2.973,2.973,0,0,0-2.9,3.04v78.892a2.973,2.973,0,0,0,2.9,3.04h54.185a2.972,2.972,0,0,0,2.9-3.04V-72.025l-6,6v23.779a2.478,2.478,0,0,1-2.321,2.611h-43.346a2.479,2.479,0,0,1-2.321-2.611V-110a2.478,2.478,0,0,1,2.321-2.611h31.972v9.713a2.962,2.962,0,0,0,2.9,3.029h10.793v7.892l6-5.989v-7.891l-13.694-12.754h-43.392Zm43.392,6,7.694,6.754h-5.373a2.478,2.478,0,0,1-2.321-2.611Zm29.013,1.486-.615.615-1.149,1.137-38.39,38.391-5.953,16.758,16.77-5.942,38.39-38.39,1.137-1.137.616-.627a18.665,18.665,0,0,0-4.213-6.592,18.663,18.663,0,0,0-6.591-4.212Zm0,2.529a18.749,18.749,0,0,1,2.727,1.648L2528.97-69.89a1.692,1.692,0,0,0-.452-1.207,2.345,2.345,0,0,0-2.6-.151L2563-108.338a2.451,2.451,0,0,1,.3-.255Zm6.626,5.559a18.651,18.651,0,0,1,1.648,2.716,2.429,2.429,0,0,1-.256.3l-37.09,37.09a2.364,2.364,0,0,0-.151-2.611,1.663,1.663,0,0,0-1.2-.453Zm-69.957,7.555a2.625,2.625,0,0,0-2.75,2.5,2.625,2.625,0,0,0,2.75,2.495H2536a2.626,2.626,0,0,0,2.751-2.495,2.625,2.625,0,0,0-2.751-2.5Zm0,9.992a2.626,2.626,0,0,0-2.75,2.5,2.625,2.625,0,0,0,2.75,2.5H2530.5l4.99-4.991Zm0,9.992a2.635,2.635,0,0,0-2.75,2.507,2.625,2.625,0,0,0,2.75,2.5h21.041l.29-.8,4.2-4.2Zm26.588,4.712a1.658,1.658,0,0,1,1.16.487c.767.767.677,2.109-.615,3.4,1.292-1.292,2.633-1.383,3.4-.616s.677,2.109-.615,3.4c1.292-1.292,2.621-1.395,3.389-.627.7.7.68,1.887-.325,3.075l-.244.244-8.333,3.4L2521-61.406l3.4-8.321.244-.244a2.969,2.969,0,0,1,1.915-.812Zm-26.588,5.28a2.626,2.626,0,0,0-2.75,2.5,2.644,2.644,0,0,0,2.75,2.518h17.5l1.775-5.014h-19.276Zm38.773,2.716-2.263,2.252A2.6,2.6,0,0,0,2538.741-62.787ZM2499.968-55.5a2.625,2.625,0,0,0-2.75,2.495,2.626,2.626,0,0,0,2.75,2.5H2536a2.626,2.626,0,0,0,2.751-2.5A2.625,2.625,0,0,0,2536-55.5h-9.679l-12.162,4.317,1.532-4.317Z"
                                            transform="translate(-2487.992 118.608)"
                                        />
                                    </svg>
                                </div>
                                <p>{about_program.right_block.description}</p>
                                <div className={classes.button}> <a href={about_program.right_block.button.link}>{about_program.right_block.button.title}</a></div>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="divider" />
                    <Grid container>
                        <div className={classes.termsConDes}>
                            <div className={classes.title}>{terms_condition.title}</div>
                            <p> {terms_condition.description}</p>
                        </div>
                        <div className={classes.termsConBottom}>
                            {terms_condition.program_term.map((data) => (
                                <><div className="section-heading">{data.title}</div>
                                    <p> {data.description}</p>
                                </>
                            ))}
                        </div>
                    </Grid>
                    <Grid container className="faq-section">
                        <Grid item xs={12} className="section-heading faqs">{faq.title}</Grid>
                        <Grid item xs={12} sm={6}>
                            <div>
                                {faq.left_block.map((data) => (
                                    <div className={classes.faqInner}>
                                        <span className={classes.affiliateFaqSubtitle}>{data.title}</span>
                                        <p>{ReactHTMLParser(data.description)}</p>
                                    </div>
                                ))}
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.faqRightContainer}>
                                {faq.right_block.map((data) => (
                                    <div className={classes.faqInner}>
                                        <span className={classes.affiliateFaqSubtitle}>{data.title}</span>
                                        <p>{ReactHTMLParser(data.description)}</p>
                                    </div>
                                ))}
                            </div>
                        </Grid>
                    </Grid>
                    <div className="contact-us-section">
                        <div className="section-heading">{contact_us?.title}</div>
                        <div>
                            <span style={{ fontWeight: 'bolder' }}>{contact_us?.bottom_block?.title}</span>
                            <p>{contact_us?.bottom_block?.description}</p>
                            <span>{ReactHTMLParser(contact_us?.bottom_block?.link)}</span>
                        </div>
                    </div>
                </Grid>
            </div>
        </Container>
    );
};

BecomeAnAffiliate.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(BecomeAnAffiliate);
